/**
 * README.md
 *
 * If you add to this enum, keep Alphabetical Order!
 * If list is out of order, use the following vscode command:
 * `cmd+shift+p > 'Sort Lines Ascending'`
 */
export enum Icons {
  Account = 'account_circle',
  Add = 'add',
  ArrowBack = 'arrow_back_2',
  ArrowDownward = 'arrow_downward',
  ArrowForward = 'play_arrow',
  ArrowRight = 'arrow_right',
  ArrowRightAlt = 'arrow_right_alt',
  ArrowUp = 'arrow_circle_up',
  ArrowUpward = 'arrow_upward',
  Article = 'article',
  Assessment = 'analytics',
  AssessRisk = 'straighten',
  Assignment = 'assignment',
  Back = 'arrow_back',
  Bolt = 'bolt',
  Calendar = 'calendar_month',
  Check = 'check',
  Checkmark = 'check_circle',
  ChevronLeft = 'chevron_left',
  ChevronRight = 'chevron_right',
  Close = 'close',
  CloudDownload = 'cloud_download',
  Construction = 'construction',
  CostJustify = 'attach_money',
  DarkMode = 'dark_mode',
  Dashboard = 'space_dashboard',
  Delete = 'delete',
  Done = 'check',
  Download = 'download_2',
  DropDown = 'arrow_drop_down',
  EarlyIntervention = 'guardian',
  Edit = 'edit',
  Education = 'school',
  Email = 'mail',
  Equal = 'equal',
  Ergonomics = 'corporate_fare',
  FastForward = 'fast_forward',
  FastRewind = 'fast_rewind',
  File = 'attach_file',
  FileDownload = 'file_download',
  Flag = 'flag',
  Fold = 'unfold_less',
  Forward = 'arrow_forward',
  FullBody = 'accessibility_new',
  HazardFlag = 'flag',
  Help = 'help_center',
  ImprovementOpportunityFlag = 'construction',
  ImprovementProject = 'bubble_chart',
  Info = 'info',
  Intercom = 'forum',
  IsmDashboard = 'local_hospital',
  JobRotation = 'rotate_left',
  KeyboardArrowDown = 'keyboard_arrow_down',
  KeyboardArrowLeft = 'keyboard_arrow_left',
  KeyboardArrowRight = 'keyboard_arrow_right',
  KeyboardDoubleArrowDown = 'keyboard_double_arrow_down',
  LightMode = 'light_mode',
  Logout = 'logout',
  Map = 'map',
  MapPin = 'location_on',
  Menu = 'menu',
  MoreHoriz = 'more_horiz',
  MoreVert = 'more_vert',
  News = 'brand_awareness',
  Note = 'edit_note',
  NotVisible = 'visibility_off',
  OpenInNew = 'open_in_new',
  PDF = 'picture_as_pdf',
  Person = 'person',
  PieChart = 'pie_chart',
  PlayCircle = 'play_circle',
  Print = 'print',
  Prioritize = 'playlist_play',
  Priority = 'swap_vertical_circle',
  RadioButtonUnchecked = 'radio_button_unchecked',
  Redo = 'redo',
  Refresh = 'refresh',
  Remove = 'remove',
  RootCauseFlag = 'search',
  Search = 'search',
  Settings = 'settings',
  Star = 'star',
  Stretching = 'directions_run',
  TakePhoto = 'photo_camera',
  Target = 'target',
  TaskProgressStepperIconComplete = 'check',
  TaskProgressStepperIconIncomplete = 'priority_high',
  TaskStep = 'circle',
  ThumbUp = 'thumb_up',
  Topic = 'topic',
  Trophy = 'emoji_events',
  Undo = 'undo',
  Unfold = 'unfold_more',
  Upload = 'cloud_upload',
  Visible = 'visibility',
  Warning = 'warning',
}
